/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { NotifierNotificationPriority } from './NotifierNotificationPriority';
import {
    instanceOfNotifierNotificationPriority,
    NotifierNotificationPriorityFromJSON,
    NotifierNotificationPriorityFromJSONTyped,
    NotifierNotificationPriorityToJSON,
} from './NotifierNotificationPriority';

/**
 * @type FxIdApplicationNotificationsScheduledNotificationItemPriority
 * Приоритет уведомления (опционально, по умолчанию NORMAL)
 * @export
 */
export type FxIdApplicationNotificationsScheduledNotificationItemPriority = NotifierNotificationPriority;

export function FxIdApplicationNotificationsScheduledNotificationItemPriorityFromJSON(json: any): FxIdApplicationNotificationsScheduledNotificationItemPriority {
    return FxIdApplicationNotificationsScheduledNotificationItemPriorityFromJSONTyped(json, false);
}

export function FxIdApplicationNotificationsScheduledNotificationItemPriorityFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationNotificationsScheduledNotificationItemPriority {
    if (json == null) {
        return json;
    }
    if (instanceOfNotifierNotificationPriority(json)) {
        return NotifierNotificationPriorityFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxIdApplicationNotificationsScheduledNotificationItemPriorityToJSON(json: any): any {
    return FxIdApplicationNotificationsScheduledNotificationItemPriorityToJSONTyped(json, false);
}

export function FxIdApplicationNotificationsScheduledNotificationItemPriorityToJSONTyped(value?: FxIdApplicationNotificationsScheduledNotificationItemPriority | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfNotifierNotificationPriority(value)) {
        return NotifierNotificationPriorityToJSON(value as NotifierNotificationPriority);
    }

    return {};
}

